// export const cursorMaker = (selectedDate: Date | number, prev: boolean): string => {
//   console.log('cursorMaker', selectedDate);
//   const dateKey = typeof selectedDate === 'number' ? selectedDate : selectedDate.toLocaleDateString();
//   const cursor = (prev ? '' : 'r=1') + '&p=' + encodeURIComponent(dateKey);
//   console.log('dateKey', dateKey);
//   console.log('cursor', cursor);
//   return cursor;
// };

export const cursorMaker = (selectedDate: Date | number, prev: boolean): string => {
  let dateKey: string;

  if (typeof selectedDate === 'number') {
    dateKey = new Date(selectedDate).toISOString();
  } else {
    const utcMidnight = new Date(
      Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0)
    );
    dateKey = utcMidnight.toISOString(); // e.g., "2025-05-22T00:00:00.000Z"
  }

  const cursor = (prev ? '' : 'r=1') + '&p=' + encodeURIComponent(dateKey);
  return cursor;
};

export const videosCursorMaker = (selectedDate: Date | number): string => {
  let dateKey: string;

  if (typeof selectedDate === 'number') {
    dateKey = new Date(selectedDate).toISOString();
  } else {
    const utcMidnight = new Date(
      Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0)
    );
    dateKey = utcMidnight.toISOString(); // e.g., "2025-05-22T00:00:00.000Z"
  }

  const cursorString = `r=0&p=${dateKey}`;
  const base64Cursor = btoa(cursorString); // base64 encode
  // console.log('dateKey', dateKey);
  // console.log('cursorString', cursorString);
  // console.log('base64Cursor', base64Cursor);
  return base64Cursor;
};
